import { render, staticRenderFns } from "./EstimatesOldSpecsItemSidepageForm.vue?vue&type=template&id=52f7d7e5&"
import script from "./EstimatesOldSpecsItemSidepageForm.vue?vue&type=script&lang=js&"
export * from "./EstimatesOldSpecsItemSidepageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports